import { render } from "./MNews.vue?vue&type=template&id=5e1c9312&scoped=true"
import script from "./MNews.vue?vue&type=script&lang=js"
export * from "./MNews.vue?vue&type=script&lang=js"

import "./MNews.vue?vue&type=style&index=0&id=5e1c9312&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1c9312"]])

export default __exports__